import JWTDecode from "jwt-decode";
import * as types from "@/modules/action-types";
import store from "@/modules";

let AuthToken = {
  tokenId: "@token_id",
  firstLogin: false,
  init(isFirstLogin) {
    this.firstLogin = isFirstLogin || false;
    this.token = "";
    return this;
  },
  save(accessToken) {
    this.token = accessToken;
    if (!accessToken) {
      let message = "Missing header: Access-Token";
      return { error: message };
    }
    let tokenPayload = JWTDecode(accessToken);
    let user = tokenPayload["user"];
    if (!user) {
      let message = "Could not get user information";
      return { error: message };
    }
    localStorage.setItem(this.tokenId, accessToken);
    localStorage.setItem("user", JSON.stringify(user));

    let payload = { user, accessToken };
    if (this.firstLogin) payload.restoreBrowserLocation = true;
    store.commit(`auth/${types.LOGIN.SUCCESS}`, payload, { root: true });
    return {};
  },
};
export default Object.create(AuthToken);
